export default __webpack_public_path__ + "static/27-a3a0372efdb4571484f64face32d7ef3.png";